import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface PlayerState {
  captionsEnabled: boolean
  playerButtonsDisabled: boolean
}

export const playerInitialState: PlayerState = {
  captionsEnabled: false,
  playerButtonsDisabled: false
}

export const playerSlice = createSlice({
  name: 'player',
  initialState: playerInitialState,
  reducers: {
    setCaptionsEnabled: (state, action: PayloadAction<boolean>) => {
      state.captionsEnabled = action.payload
    },
    setPlayerButtonsDisabled: (state, action: PayloadAction<boolean>) => {
      state.playerButtonsDisabled = action.payload
    }
  }
})

export const {
  setCaptionsEnabled,
  setPlayerButtonsDisabled
} = playerSlice.actions

export default playerSlice.reducer
